export { default } from "./ActiveLink";
